const analyticsEvent = require('./analyticsEvent');
let trackingElements;

const _track = (trackingElem, event) => {
    analyticsEvent(trackingElem.getAttribute('data-event-category'), event, trackingElem.getAttribute('data-event-label'));
};

const init = root => {
    root = root || document;

    /* track events from html attributes */
    trackingElements = [...root.querySelectorAll('[data-event][data-event-category][data-event-label]')];

    if (trackingElements.length > 0) {
        trackingElements.forEach(trackingElem => {
            const data = trackingElem.data || {};
            const event = trackingElem.getAttribute('data-event');
            if (data.__trackingEvent === event) return;
            data.__track = () => {
                _track(trackingElem, event);
            };
            data.__trackingEvent = event;
            trackingElem.data = data;
            trackingElem.addEventListener(event, data.__track);
        });
    }
};

const destroy = root => {
    /* track events from html attributes */
    trackingElements = [...root.querySelectorAll('[data-event][data-event-category][data-event-label]')];

    if (trackingElements.length > 0) {
        trackingElements.forEach(trackingElem => {
            const data = trackingElem.data;
            if (!data) return;
            trackingElem.removeEventListener(data.__trackingEvent, data.__track);
            delete data.__trackingEvent;
            delete data.__track;
        });
    }
};

init();

module.exports.init = init;
module.exports.destroy = destroy;
